import type { closedOperationsData } from "./type";
import closedOperationsDataList from "../../../data/closedOperationsData.json";

export class ClosedOperationsService {
  async getClosedOperationsFile(clientId: number, filters: any) {
    const { data } = await this.getClosedOperations(
      clientId,
      0,
      1000000,
      filters
    );
    return data;
  }

  async getClosedOperations(
    clientId: number,
    page: number,
    size: number,
    filters: any
  ): Promise<{ data: closedOperationsData }> {
    if (!clientId) {
      throw new Error("clientId is required.");
    }

    let filteredClosedOperations = closedOperationsDataList.data.filter(
      (operations) => operations.clientId === clientId
    );

    if (filters) {
      if (filters.date && filters.date.length === 2) {
        const [startRaw, endRaw] = filters.date.map((d: string) => new Date(d));

        // Normalizar las fechas al inicio del día
        const start = new Date(startRaw.setHours(0, 0, 0, 0));
        const end = new Date(endRaw.setHours(23, 59, 59, 999)); // incluir todo el día

        filteredClosedOperations = filteredClosedOperations.filter((item) => {
          const [dd, mm, yyyy] = item.date.split("/");
          const itemDate = new Date(`${yyyy}-${mm}-${dd}T00:00:00`);
          return itemDate >= start && itemDate <= end;
        });
      }
    }

    const total = filteredClosedOperations.length;
    const start = page * size;
    const end = start + size;
    const paginatedData = filteredClosedOperations.slice(start, end);
    return {
      data: {
        total,
        totalPages: Math.ceil(total / size),
        page,
        pageSize: size,
        operations: paginatedData,
      },
    };
  }
}
